import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#000",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "m14.01 6.937.584 1.388c.07.165.257.269.444.269h1.636c.795 0 1.402.538 1.402 1.243v4.97c0 .705-.607 1.244-1.402 1.244H7.326c-.794 0-1.402-.539-1.402-1.243V9.837c0-.705.608-1.243 1.402-1.243h1.636c.21 0 .374-.104.444-.27l.584-1.387zm-5.86-.065h-.824c-1.544 0-3.123 1.12-3.123 2.965v4.97c0 1.845 1.58 2.965 3.123 2.965h9.348c1.544 0 3.124-1.12 3.124-2.964V9.837c0-1.845-1.58-2.965-3.124-2.965h-.823l-.254-.603a1.722 1.722 0 0 0-1.587-1.054H9.99c-.692 0-1.318.415-1.586 1.054z" }),
      _createElementVNode("path", { d: "M12 13.316a1.316 1.316 0 1 0 0-2.632 1.316 1.316 0 0 0 0 2.632zm0 1.722a3.038 3.038 0 1 0 0-6.076 3.038 3.038 0 0 0 0 6.076zM22.279 3.899A2.177 2.177 0 0 0 20.1 1.72h-4.05V0h4.05A3.899 3.899 0 0 1 24 3.899v4.05h-1.722zM1.722 3.899c0-1.203.974-2.178 2.177-2.178h4.05V0H3.9A3.899 3.899 0 0 0 0 3.899v4.05h1.722zM20.101 22.279a2.177 2.177 0 0 0 2.177-2.178v-4.05H24v4.05A3.899 3.899 0 0 1 20.101 24h-4.05v-1.722zM1.722 20.101c0 1.203.974 2.177 2.177 2.177h4.05V24H3.9A3.899 3.899 0 0 1 0 20.101v-4.05h1.722z" })
    ], -1)
  ])))
}
export default { render: render }